"use client";

import { Header } from "@/components/shared/public/blogs";
import type { MeasurementServicePricingConfig } from "@/lib/pricing";
import {
  AdditionalInfo,
  PriceCalculation,
  ServiceDescription,
  ServiceObjects,
} from "@/views/public/three-sixty-service";
import { useTranslations } from "next-intl";
import { header } from "../../../../../public/images/blogs/ThreeSixtyDegreeMatterportService";

type MatterportServiceContentProps = {
  pricingConfig: MeasurementServicePricingConfig;
};

export default function MatterportServiceContent({
  pricingConfig,
}: MatterportServiceContentProps) {
  const t = useTranslations("blogs.ThreeSixtyDegreeMatterportService");
  return (
    <div className="[--h1-weight:500] [--heading-scale:0.6]">
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
        width={1200 * 0.4}
        height={976 * 0.4}
      />
      <ServiceDescription />
      <ServiceObjects />
      <AdditionalInfo />
      <PriceCalculation pricingConfig={pricingConfig} />
    </div>
  );
}
